module.exports = __webpack_public_path__ + "img/character-photo-language.4b852fa2.jpg";